module.exports = __webpack_public_path__ + "static/img/company.bbf8155.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr/company.png
// module id = LkfS
// module chunks = 26